import {
  feature as turfFeature,
  featureCollection as turfFeatureCollection,
} from '@turf/helpers'

export const POINT = 'Point'
export const FEATURE = 'Feature'
export const POLYGON = 'Polygon'
export const MULTIPOLYGON = 'MultiPolygon'
export const FEATURECOLLECTION = 'FeatureCollection'

export const toFeature = (geoJson = {}) => {
  const { type } = geoJson

  if (!type) {
    return null
  }

  if (type === FEATURECOLLECTION || type === FEATURE) {
    return geoJson
  }

  return turfFeature(geoJson)
}

export const toFeatureCollection = (geoJson = {}) => {
  const feature = toFeature(geoJson)

  if (feature && feature.type === FEATURECOLLECTION) {
    return feature
  } else if (feature && feature.type === FEATURE) {
    return turfFeatureCollection([feature])
  }

  return null
}

export const isPoint = (geoJson = {}) => {
  const feature = toFeature(geoJson)
  return feature && feature.geometry && feature.geometry.type === POINT
}

export default {
  POINT,
  FEATURE,
  POLYGON,
  MULTIPOLYGON,

  toFeature,
  isPoint,
}
